import { ACTIVE_COURIER_DETAIL_SORT_BY_STATUS } from '@src/pages/DeliveryDashboard/models/model-constants';
import { IOrder } from '@src/pages/DeliveryDashboard/models/model-interface';
import PIEText from '@src/shared/components/PIEText';
import React, { FC } from 'react';
import CourierDetailOrderCard from '../CourierDetailOrderCard';
import { PIEComponentUtil } from '@src/shared/components/PIEComponentUtil';
import { OrderStatus } from '@src/pages/DeliveryDashboard/models/model-enum';
import CourierDetailDeliveredOrderCard from '../CourierDetailDeliveredOrderCard';

interface ICourierCurrentDeliveryProps {
  title?: string;
  data: IOrder[];
}

export const CourierCurrentDelivery: FC<ICourierCurrentDeliveryProps> = ({ title, data }) => {
  return (
    <>
      {title !== '' ? (
        <PIEComponentUtil paddingTop="var(--xds-spacing-d)">
          <PIEText
            text={title}
            color="var(--xds-color-content-default)"
            size="var(--xds-font-size-14)"
          />
        </PIEComponentUtil>
      ) : null}
      {data
        ?.sort(
          (a: IOrder, b: IOrder) =>
            ACTIVE_COURIER_DETAIL_SORT_BY_STATUS[a.status] -
            ACTIVE_COURIER_DETAIL_SORT_BY_STATUS[b.status]
        )
        .map((order: IOrder, index: number) => {
          return order.status !== OrderStatus.Delivered ? (
            <CourierDetailOrderCard key={index} orderData={order} />
          ) : (
            <CourierDetailDeliveredOrderCard key={index} orderData={order} />
          );
        })}
    </>
  );
};

export default CourierCurrentDelivery;
